import React from 'react';

interface Props {
  onTerms: () => void;
  onPrivacy: () => void;
}

export default function Footer({ onTerms, onPrivacy }: Props) {
  return (
    <footer className="py-6 px-4 border-t" style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border-color)' }}>
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
          © {new Date().getFullYear()} rastreadordebienes.co · SYSTELEC ELECTRONICA E INFORMATICA
        </p>
        <div className="flex gap-5 text-xs">
          <button onClick={onTerms} className="text-[#2563EB] hover:underline transition-colors bg-transparent border-0 cursor-pointer p-0">
            Términos y condiciones
          </button>
          <button onClick={onPrivacy} className="text-[#2563EB] hover:underline transition-colors bg-transparent border-0 cursor-pointer p-0">
            Política de privacidad
          </button>
        </div>
      </div>
    </footer>
  );
}
